export const VERTICAL_CATEGORY_MAP = {
  live_animals: '/pets',
  vehicles: {
    __default: '/auto',
    cars: '/auto/cars',
    motorbikes: '/auto/motorbikes',
    caravans: '/auto/caravans',
    boats: '/auto/boats',
    trucks: '/auto/trucks',
    commercial: '/auto/commercial',
  },
};

export const VERTICAL_SLUGS = ['pets', 'auto/cars', 'auto/motorbikes', 'auto/caravans', 'auto/boats', 'auto/trucks', 'auto/commercial'];

export const verticalPathFor = (item) => {
  if (!item) return '/catalog';
  const entry = VERTICAL_CATEGORY_MAP[item.category];
  if (!entry) return '/catalog';
  if (typeof entry === 'string') return entry;
  if (item.subcategory && entry[item.subcategory]) return entry[item.subcategory];
  return entry.__default || '/catalog';
};

export const VEHICLE_SUBCATEGORY_BY_SLUG = {
  cars: 'cars',
  motorbikes: 'motorbikes',
  caravans: 'caravans',
  boats: 'boats',
};
